import { AresCompanyDetails } from './AresApiService.types'
import { AxiosInstance } from 'axios'

export const getAresDetails = async (axiosInstance: AxiosInstance, companyId: string): Promise<AresCompanyDetails> => {
    const { data: { data: aresDetails } } = await axiosInstance.get<MakeAxiosResponse<AresCompanyDetails>>('ares', { params: { companyId } })
    return aresDetails
}